/**
 * AuthorHeader — small label above an assistant message identifying the
 * source ("Ion"). The orange dot is the AI marker — paired with the
 * doc-block's left-border it forms the design-locked AI provenance signal.
 *
 * Timestamps are intentionally omitted on assistant messages — they
 * clutter the doc surface and rarely add value when the user can see
 * the conversation flow. User-message timestamps still render via
 * ChatMessage::UserMessage so users can self-orient their own turns.
 */

import { IconIonBolt } from '../shared/Icons.jsx'

/**
 * @param {object} props
 * @param {string} [props.name='Ion']
 */
export function AuthorHeader({ name = 'Ion' }) {
  return (
    <header class="ion-author">
      <IconIonBolt size={14} className="ion-author__bolt" />
      <span class="ion-author__name">{name}</span>
    </header>
  )
}
